import React, { FC } from 'react';
import { get } from 'lodash';

import Icon, { IconmoonFont } from 'vibo-ui/Icon';

import { useEvent } from 'components/context/EventContext';

import useStyles from '../Location/style';

const SongsInfo: FC = () => {
  const classes = useStyles();

  const { event } = useEvent();

  const sectionsWithSongs = event?.sectionsWithSongs ?? get(event, 'sectionsWithSongsTotal');

  return !!event ? (
    <div className={classes.location}>
      <Icon icon={IconmoonFont['musicNoteDoubleOutlined-16']} />
      <span className="name">
        Sections with songs <b>{sectionsWithSongs}</b>
      </span>
    </div>
  ) : null;
};

export default SongsInfo;
